import { FlexCol, FlexRow } from '@/components/common/Flex';
import { Paragraph } from '@/components/common/Typography';
import { calculatePriceAfterPromotion } from '@/services/billing';
import { toDollarsWithCents } from '@/util/currency';
import { Box, FlexProps, Text } from '@chakra-ui/react';
import { PromotionCodeFieldsFragment } from '@common/graphql/generated';

type MembershipPriceDetailsProps = {
    title: string;
    subtitle: string;
    disabled?: boolean;
    promotionCode?:
        | Pick<PromotionCodeFieldsFragment, 'amountOff' | 'percentOff' | 'code'>
        | null
        | undefined;
    price: number;
} & FlexProps;

const MembershipPriceDetails = ({
    title,
    subtitle,
    promotionCode,
    disabled,
    price,
    ...rest
}: MembershipPriceDetailsProps) => {
    return (
        <FlexRow align="flex-start" justify="space-between" gap={2} {...rest}>
            <FlexCol grow={1}>
                <FlexRow justify="space-between" align="center">
                    <FlexRow grow={1}>
                        <PriceLabel title={title} subtitle={subtitle} />
                    </FlexRow>
                    <Box
                        fontWeight="semibold"
                        fontSize="sm"
                        textAlign="right"
                        textDecoration={
                            promotionCode || disabled ? 'line-through' : 'none'
                        }
                    >
                        {toDollarsWithCents(price)} / year
                    </Box>
                </FlexRow>

                {promotionCode && (
                    <FlexRow justify="space-between" align="center">
                        <FlexRow grow={1}>
                            <PriceLabel
                                title="After promotion code discount"
                                subtitle={`${promotionCode.code}: ${promotionCode.amountOff ? `${toDollarsWithCents(promotionCode.amountOff)}` : ''} ${promotionCode.percentOff ? `${promotionCode.percentOff}%` : ''} off`}
                            />
                        </FlexRow>
                        <Box
                            fontWeight="semibold"
                            fontSize="sm"
                            textAlign="right"
                        >
                            {toDollarsWithCents(
                                calculatePriceAfterPromotion({
                                    price,
                                    promotionCode,
                                })
                            )}{' '}
                            / year
                        </Box>
                    </FlexRow>
                )}
            </FlexCol>
        </FlexRow>
    );
};

const PriceLabel = ({
    title,
    subtitle,
}: Omit<MembershipPriceDetailsProps, 'price'>) => (
    <FlexCol fontSize="md">
        <Text fontWeight="semibold">{title}</Text>
        <Box h={6} w="full" position="relative">
            <Paragraph key={subtitle} color="textMuted" fontSize="sm">
                {subtitle}
            </Paragraph>
        </Box>
    </FlexCol>
);

export default MembershipPriceDetails;
